import React, { useEffect, useState } from "react";

export function Handwritten({ words, className = "", interval = 3400 }) {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setI((v) => (v + 1) % words.length), interval);
    return () => clearTimeout(t);
  }, [i, words.length, interval]);

  return (
    <span className="hw-wrap" data-testid="hero-handwritten" aria-label={words.join(", ")}>
      <span key={i} className={`hw-word ${className}`}>
        {words[i]}
      </span>
    </span>
  );
}
